import { render, staticRenderFns } from "./advisorDashboardView.vue?vue&type=template&id=97704bf4&scoped=true"
import script from "./advisorDashboardView.vue?vue&type=script&lang=js"
export * from "./advisorDashboardView.vue?vue&type=script&lang=js"
import style0 from "./advisorDashboardView.vue?vue&type=style&index=0&id=97704bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97704bf4",
  null
  
)

export default component.exports